import React, { Component } from 'react';

import SelectionTab2 from './../../../../../components/ZUILib/SelectionTab2';

import commonUtil from '../../../../../utils/commonUtil';

class PriceRangeFilter extends Component {
  constructor(props) {
    super(props);
    this.labels = this.props.labels;
  }

  render() {
    const lowerPrice = 'Menor a mayor precio' ||
      commonUtil.getLabel(this.labels.GuestviewPage, 'guestview.lower.price.by.label'); // TODO: update label
    const higherPrice = 'Mayor a menor precio' ||
      commonUtil.getLabel(this.labels.GuestviewPage, 'guestview.best.price.by.label');  // TODO: update label

    const priceRangeFilterData = [{
      id: 'Ascending',
      value: lowerPrice,
      labelResourceId: lowerPrice,
    },
    {
      id: 'Descending',
      value: higherPrice,
      labelResourceId: higherPrice,
    }];

    const styleForSelector = {
      gap: 10,
      height: 40,
      fontSize: 14,
      width: '100%',
      border: 'none',
      display: 'flex',
      paddingLeft: 15,
      fontWeight: 700,
      color: '#767676',
      alignItems: 'center',
      justifyContent: 'space-around',
    };

    return (
      <div style={{ display: 'flex', width: '50%' }}>
        <SelectionTab2
          disable={false}
          id="filterEvent"
          value={lowerPrice}
          optionText="value"
          optionValue="value"
          classname="cSelect"
          style={styleForSelector}
          options={priceRangeFilterData}
          ref={ref => this.getRangePrice = ref}
          inlineStyleDropdown={{
            border: 'none',
            paddingLeft: 0,
            fontSize: 14,
            textOverflow: 'ellipsis',
            marginRight: 'auto',
            whiteSpace: 'nowrap',
            maxWidth: '80%',
          }}
          handleSelectedOption={this.props.handlePriceRangeFilter}
        />
      </div>
    );
  }
}


export default PriceRangeFilter;
